import React from "react";
import { useLanguagesContext } from "hooks/useContextAll";
import { publicRoutesDataTranslation } from "data/routes/publicRoutesDataTranslation";
import NavbarLink from "./NavbarLink";

const NavbarList = () => {
    const currentLanguage = useLanguagesContext().language;

    return (
        <ul className={`navbar-links-list ${currentLanguage === 'en' ? 'ltr' : 'rtl'}`}>
            {Object.entries(publicRoutesDataTranslation).map((item, idx) => {
                return (
                    <NavbarLink
                        key={`navbar-link-${idx}`}
                        text={item[1][currentLanguage]}
                        path={item[1].path}
                    />
                );
            })}
        </ul>
    );
};

export default NavbarList;
